import styled from 'styled-components'
import { border, color, layout, shadow, space, zIndex } from 'styled-system'

export const Box = styled.div`
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
  position: relative;

  ${border};
  ${color};
  ${layout};
  ${space};
  ${shadow.boxShadow};
  ${zIndex};
`
